import Vue from 'vue'
// eslint-disable-next-line import/named
import { permissionDirective } from './permission-directive'
import padLeftZeroDirective from './padLeftZero'
import mascaraOpcionalDirective from './mascaraOpcional'
import semCaracteresEspeciaisDirective from './semCaracteresEspeciais'

Vue.directive('isAllowed', permissionDirective)
Vue.directive('padLeftZero', padLeftZeroDirective)
Vue.directive('mascaraOpcional', mascaraOpcionalDirective)
Vue.directive('semCaracteresEspeciais', semCaracteresEspeciaisDirective)
